import React from "react";
import Logo from "../Logo";
import { Link } from "react-router-dom";
import { SkipBack } from "react-feather";
import CreateRoomForm from "./CreateRoomForm";

import { classNames } from "../../utils/common";

function CreateRoom({ className, iconStyle }) {
  const renderLoginAction = () => {
    return (
      <Link to="/">
        <button title={"Go Back to Login"} className={className}>
          <SkipBack className={classNames("text-secondary", iconStyle)} />
        </button>
      </Link>
    );
  };

  return (
    <div className="flex items-center justify-center h-screen w-screen bg-signal">
      <div className="w-5/6 sm:w-2/3 lg:w-1/3 p-5 lg:py-8 bg-primary-dark shadow-2xl">
        <Logo className="w-2/3 mx-auto" />

        <CreateRoomForm />
        <div className="mt-2">{renderLoginAction()}</div>
      </div>
    </div>
  );
}

export default CreateRoom;
